import Vue from 'vue'
import {CONSTANTS_PROD, CONSTANTS_TEST, TEST_ENVIRONMENT} from '../../config/constants'
import axios from 'axios'
import {bus} from '../../components/Login/bus-login'
import router from '../../router'


export var login_service = new Vue({
    data() {
        return {
            constants: {},
            full_url: ''
        }
    },
    methods: {
        async login(data) {

            await axios({
                method: 'POST',
                url: this.full_url + 'auth/login',
                data: {
                    email: data.email,
                    password: data.password
                }
            })
                .then(response => {
                    if (response.data.accessToken) {
                        sessionStorage.setItem('token', JSON.stringify(response.data));
                    }

                    bus.login(response.data)
                })
                .catch(function (error) {
                    //console.log('Error ' + error);
                    bus.login(error)
                })
        },
        async RessetPass(email){
            await axios({
                method: 'GET',
                url: this.full_url + 'users/resetpassword/'+email
            })
                .then(function (response) {
                    bus.responseressetpass(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async vallogin() {
            const token = JSON.parse(sessionStorage.getItem("token"))
            await axios({
                method: 'GET',
                url: this.full_url + 'auth/user',
                headers: {'Authorization': 'bearer ' + token.accessToken}
            })
                .then(response => {
                    if (response.data.user_type_id.user_type_id === 1 && response.data.user_status === 1) {
                        sessionStorage.setItem('user', JSON.stringify(response.data));
                        router.push('/dashboard')
                    } else {
                        bus.errorlogin('Usuario Incorrecto o inactivo')
                    }
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        }

    },
    created() {
        (TEST_ENVIRONMENT) ? this.constans = CONSTANTS_TEST : this.constans = CONSTANTS_PROD;
        this.full_url = this.constans.URL_API + this.constans.VERSION_API;
    }
})